import { ControlUnitAPIResponse } from '../../../redux/controlUnit/api/ControlUnit.model';
import { MachineType } from '../../../redux/stoerkID/StoerkIdAPI.model';

export const getChannelsByComposableDevice = (
  machineType: MachineType,
  controlUnits: ControlUnitAPIResponse[] = [],
  commanderId: string
) => {
  const channelList = [];

  const actionsChannelsIndex =
    machineType?.labels['merchandise_channel_actions']?.split('-') || [];
  const [initialActionsChannels, _endActionsChannels] =
    actionsChannelsIndex.map((value) => Number.parseInt(value, 10));

  const eventsChannelsIndex =
    machineType?.labels['merchandise_channel_events']?.split('-') || [];
  const [initialEventChannels, _endEventChannels] = eventsChannelsIndex.map(
    (value) => Number.parseInt(value, 10)
  );
  const sensorChannelsIndex =
    machineType?.labels['merchandise_channel_sensors']?.split('-') || [];
  const [initialSensorChannels, endSensorChannels] = sensorChannelsIndex.map(
    (value) => Number.parseInt(value, 10)
  );

  const virtualChannelsIndex =
    machineType?.labels['merchandise_channel_virtual_sensors']?.split('-') ||
    [];
  const [initialVirtualChannels, endVirtualChannels] = virtualChannelsIndex.map(
    (value) => Number.parseInt(value, 10)
  );

  for (let i = initialActionsChannels; i <= endSensorChannels; i++) {
    const channelAddress = machineType?.labels[`channels.${i}.address`];
    const channel = machineType?.labels[`channels.${i}.channel`] ?? '';

    const controlUnit = controlUnits.find(
      (cu) => cu.address === channelAddress
    );
    if (!controlUnit) {
      return channelList;
    }

    let channelType: string;
    if (i < initialEventChannels) {
      channelType = 'action';
    } else if (i < initialSensorChannels) {
      channelType = 'event';
    } else {
      channelType = 'sensordata';
    }

    const value = {
      deviceId: commanderId,
      controlUnitId: controlUnit?.id ?? '',
      channel,
      channelType,
    };
    channelList.push(value);
  }
  //add virtual channels
  const virtualChannels = [
    {
      deviceId: commanderId,
      controlUnitId: '',
      channel: '',
      channelType: 'virtual_superheat',
    },
    {
      deviceId: commanderId,
      controlUnitId: '',
      channel: '',
      channelType: 'virtual_superheat',
    },
  ];
  for (let i = initialVirtualChannels; i <= endVirtualChannels; i++) {
    channelList.push(virtualChannels[i - initialVirtualChannels]);
  }

  return channelList;
};
